import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { PromptPersistActionTypeEnum } from '../../models/prompt-persist-dialog.model';

export class PromptPersistConfirmDialogData {
  header: string;
  showIcon: boolean = false;
  message: string;
  noActionText: string = 'No';
  yesActionText: string = 'Yes';
  yesButtonColor: string = 'primary';
  showDontAskAgain: boolean = false;
  valDontAskAgain: boolean = false;
}

@Component({
  selector: 'sd-prompt-persist-confirm-dialog',
  templateUrl: './prompt-persist-confirm-dialog.component.html',
  styleUrls: ['./prompt-persist-confirm-dialog.component.scss']
})
export class PromptPersistConfirmDialogComponent implements OnInit {
  dontAskAgainVal: boolean = false;
  isDontAskAagainUpdated: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PromptPersistConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PromptPersistConfirmDialogData
  ) {}

  ngOnInit() {
    this.data = {
      ...new PromptPersistConfirmDialogData(),
      ...this.data
    };
    this.isDontAskAagainUpdated = false;
    this.dontAskAgainVal = this.data.valDontAskAgain;
  }

  updatePromptPersist($event: MatCheckboxChange) {
    this.isDontAskAagainUpdated = true;
    this.dontAskAgainVal = $event.checked;
  }

  yesActionClick() {
    const yesActionVal =
      this.isDontAskAagainUpdated === false
        ? PromptPersistActionTypeEnum.YesAction_Only
        : this.dontAskAgainVal
        ? PromptPersistActionTypeEnum.YesAction_DontPrompt_Checked
        : PromptPersistActionTypeEnum.YesAction_DontPrompt_UnChecked;
    this.dialogRef.close(yesActionVal);
  }

  noActionClick() {
    const noActionVal =
      this.isDontAskAagainUpdated === false
        ? PromptPersistActionTypeEnum.NoAction_Only
        : this.dontAskAgainVal
        ? PromptPersistActionTypeEnum.NoAction_DontPrompt_Checked
        : PromptPersistActionTypeEnum.NoAction_DontPrompt_UnChecked;
    this.dialogRef.close(noActionVal);
  }
}
